import { Route } from "@angular/router";
import { ConfirmarCadastroPage } from "./confirmar-cadastro.page";

export const ConfirmarCadastroRouter: Route[] = [
  { path: 'confirmar-cadastro', component: ConfirmarCadastroPage }
];